import PropTypes from 'prop-types';
import React, {
  useEffect,
  useState,
} from 'react';

import { Map, Iterable } from 'immutable';
import isEmpty           from 'lodash/isEmpty';

import Grid from '@mui/material/Grid';

import Autocomplete from '../../Api/Autocomplete';

function Geolocation({ name, value, onChange, disabled }) {
  const [state, setState] = useState(new Map());
  const apiKey = (window.EXTRA_DATA || {}).PLACES_API_KEY;

  const geolocation = state.get('geolocation', !isEmpty(value) ? value.get('geolocation') : {});
  const text = state.get('text', !isEmpty(value) ? value.getIn(['geolocation', 'fullAddress']) : '');

  useEffect(() => {
    onChange(name, new Map({ geolocation }));
  }, [geolocation]);

  const onPlaceSelect = (place) => {
    if (isEmpty(place)) {
      setState(state.set('geolocation', {}));
      return;
    }

    const parsedGeolocation = {
      latitude:    `${place.latitude}`,
      longitude:   `${place.longitude}`,
      countryCode: place.country,
      'state':     place.administrative_area,
      city:        place.locality,
      postalCode:  place.postal_code,
      street:      place.street,
    };

    setState(state.set('geolocation', parsedGeolocation));
  };

  return (
    <Grid container>
      <Grid item xs={12} sx={{ mt: 2 }}>
        <Autocomplete
          disabled={disabled}
          onPlaceSelect={onPlaceSelect}
          apiKey={apiKey}
          name={name}
          value={text}
        />
      </Grid>
    </Grid>
  );
}

Geolocation.defaultProps = {
  name:     null,
  value:    null,
  onChange: null,
  disabled: false,
};

Geolocation.propTypes = {
  name:     PropTypes.string,
  value:    PropTypes.objectOf(Iterable),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
};

export default Geolocation;
